import { render } from "./Deactivated.vue?vue&type=template&id=dae0eb42"
import script from "./Deactivated.vue?vue&type=script&lang=js"
export * from "./Deactivated.vue?vue&type=script&lang=js"
script.render = render

export default script